
import { retrieveData } from "../LocalConnection/LocalConnection";
const PrivacyPolicy = ({ full_name }) => {
  const loading = false;
  const globalData = JSON.parse(retrieveData("QR_GLOBAL_DATA"));

  const restaurant = globalData?.[0];
  const restaurantEmail =
    restaurant?.restaurant_email || "support@uprestro.com";
  const restaurantMobile = restaurant?.restaurant_mobile_no || "";
  const restaurantName = restaurant?.restaurant_name || full_name;

  return (
    <>
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.heading}>Privacy Policy</h1>

          <p style={styles.text}>
            <b>Last Updated: {new Date().toLocaleDateString()}</b>
          </p>

          <p style={styles.text}>
            At <b>{restaurantName || full_name}</b> (“Company”, “we”, “our”, or
            “us”), we are committed to protecting your personal information.
            This Privacy Policy outlines how we collect, use, store, and
            safeguard your information when you access our platform or place an
            order.
          </p>

          <h3 style={styles.subheading}>1. Information We Collect</h3>
          <p style={styles.text}>
            We collect only the information necessary to deliver our services.
            This may include:
          </p>

          <ul style={styles.list}>
            <li>Full Name</li>
            <li>Phone Number</li>
            <li>Email Address</li>
            <li>Delivery Address</li>
            <li>Order History and Preferences</li>
            <li>
              Transaction and Payment Details (handled by secure partners)
            </li>
            <li>Device & Usage Information</li>
          </ul>

          <h3 style={styles.subheading}>2. How We Use Your Information</h3>
          <p style={styles.text}>
            Your data may be used for the following purposes:
          </p>

          <ul style={styles.list}>
            <li>Processing and delivering orders</li>
            <li>Sending order updates via SMS, WhatsApp, or Email</li>
            <li>Providing customer support</li>
            <li>Detecting and preventing fraudulent activity</li>
            <li>Enhancing and improving our services</li>
          </ul>

          <h3 style={styles.subheading}>3. Data Sharing</h3>
          <p style={styles.text}>
            We do <b>not</b> sell or share your information with unauthorized
            third parties. We may share essential data with:
          </p>

          <ul style={styles.list}>
            <li>Delivery Partners</li>
            <li>Payment Gateways</li>
            <li>Technical Service Providers</li>
          </ul>

          <p style={styles.text}>
            All partners follow strict data protection and confidentiality
            protocols.
          </p>

          <h3 style={styles.subheading}>4. Data Security</h3>
          <p style={styles.text}>
            We use industry-standard security measures, including encrypted data
            transfer, secure storage, and restricted access systems.
          </p>

          <h3 style={styles.subheading}>5. Your Rights</h3>
          <p style={styles.text}>
            You may request access, correction, or deletion of your personal
            data by contacting us at:
          </p>

          <p style={styles.text}>
            <b>{restaurantEmail || "support@uprestro.com"}</b>
          </p>
        </div>
      </div>
    </>
  );
};

const styles = {
  container: {
    padding: "40px",
    backgroundColor: "#f2f4f8",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
  },
  card: {
    backgroundColor: "#ffffff",
    padding: "40px",
    borderRadius: "16px",
    boxShadow: "0px 6px 20px rgba(0,0,0,0.1)",
    maxWidth: "900px",
  },
  heading: {
    color: "#2c3e50",
    marginBottom: "20px",
  },
  subheading: {
    marginTop: "25px",
    marginBottom: "10px",
    color: "#2c3e50",
  },
  text: {
    fontSize: "16px",
    color: "#34495e",
    lineHeight: "1.6",
  },
  list: {
    marginLeft: "20px",
    color: "#34495e",
    marginBottom: "10px",
  },
};

export default PrivacyPolicy;
